import { ref, computed } from 'vue';

const isCollapsed = ref(false);
const isMobileOpen = ref(false);

// Reactive viewport-mobile flag backed by a single matchMedia listener.
// Previously `toggle()` read `window.innerWidth` at click time, so resizing
// across the 768 breakpoint while in `isCollapsed=true` made the next toggle
// flip `isMobileOpen` instead of expanding — looked like a dead click on the
// hamburger button. matchMedia keeps `isMobile` in sync at all times.
const isMobile = ref(false);

// SSR / test guard: matchMedia is not present in non-browser environments.
if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
  const mql = window.matchMedia('(max-width: 768px)');
  isMobile.value = mql.matches;
  // `addEventListener` is the modern API; fall back to `addListener` for
  // older Safari (still in field) where the change event lives on the legacy
  // surface only.
  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', (e) => {
      isMobile.value = e.matches;
    });
  } else if (typeof (mql as MediaQueryList & { addListener?: (cb: (e: MediaQueryListEvent) => void) => void }).addListener === 'function') {
    (mql as MediaQueryList & { addListener: (cb: (e: MediaQueryListEvent) => void) => void }).addListener((e) => {
      isMobile.value = e.matches;
    });
  }
}

export function useSidebar() {
  const toggle = () => {
    if (isMobile.value) {
      isMobileOpen.value = !isMobileOpen.value;
    } else {
      isCollapsed.value = !isCollapsed.value;
    }
  };

  const collapse = () => {
    isCollapsed.value = true;
  };

  const expand = () => {
    isCollapsed.value = false;
  };

  const openMobile = () => {
    isMobileOpen.value = true;
  };

  const closeMobile = () => {
    isMobileOpen.value = false;
  };

  const sidebarClasses = computed(() => ({
    'collapsed': isCollapsed.value,
    'mobile-open': isMobileOpen.value,
  }));

  const wrapperClasses = computed(() => ({
    'sidebar-collapsed': isCollapsed.value,
  }));

  return {
    isCollapsed,
    isMobileOpen,
    toggle,
    collapse,
    expand,
    openMobile,
    closeMobile,
    sidebarClasses,
    wrapperClasses,
  };
}
